import { on } from '@ember/modifier';
import { concat } from '@ember/helper';
import type { TOC } from '@ember/component/template-only';
import { PhEye } from 'ember-phosphor-icons';

export interface TioPreviewButtonSignature {
  Args: {
    isDisabled?: boolean;
    onClick: () => void;
  };
  Element: HTMLButtonElement;
}

const TioPreviewButton: TOC<TioPreviewButtonSignature> = <template>
  <button
    {{on "click" @onClick}}
    type="button"
    disabled={{@isDisabled}}
    class={{concat
      "flex flex-col items-center text-sm "
      (if @isDisabled "text-gray-400 hover:text-gray-400" "text-ocean-600 hover:text-ocean-800")
    }}
    ...attributes
  >
    <PhEye @size="20" @weight="fill" aria-hidden="true" />
    <span class="text-xs">Preview</span>
  </button>
</template>;

export default TioPreviewButton;
